import Navbar from "../components/Navbar"
import Hero from "../components/Hero"
import Services from "../components/Services"
import Process from "../components/Process"
import Industries from "../components/Industries"
import Testimonials from "../components/Testimonials"
import FAQ from "../components/FAQ"
import CTA from "../components/CTA"
import Footer from "../components/Footer"

function ServicesPage({ openModal }){

return(

<>

<Navbar openModal={openModal} />
<Hero openModal={openModal} />
<Services/>
<Process/>
<Industries/>
<Testimonials/>
<FAQ/>
<CTA openModal={openModal} />
<Footer/>

</>

)

}

export default ServicesPage;;